import React from "react";
import {
  SimpleGrid,
  AccordionItem,
  AccordionButton,
  Box,
  AccordionIcon,
  AccordionPanel,
  Accordion,
} from "@chakra-ui/react";
import useTranslate from "hooks/useTranslate";
import useV2 from "hooks/useV2";
import Attribute from "components/Attribute";
import TinyHeading from "components/TinyHeading";
import Panel from "components/Panel";

const V2AttributesContainer = () => {
  const translate = useTranslate();
  const { metadata } = useV2();

  return metadata?.attributes && metadata.attributes.length > 0 ? (
    <Accordion
      w="full"
      allowToggle
      defaultIndex={0}
      borderBottomRadius="md"
      overflow="hidden"
    >
      <AccordionItem border="none">
        <AccordionButton
          py="3"
          bg="dark.900"
          _hover={{ bg: "dark.800" }}
          position="relative"
        >
          <Box flex="1" textAlign="left">
            <TinyHeading opacity="1">
              {translate("nftAttrs:label", {
                count: metadata.attributes.length,
              })}
            </TinyHeading>
          </Box>

          <AccordionIcon w="6" h="auto" position="absolute" right="3" />
        </AccordionButton>

        <AccordionPanel p="0">
          <Panel borderTopRadius="none">
            <SimpleGrid columns={{ base: 2, sm: 3 }} gap="3">
              {metadata.attributes.map((attribute, i) => (
                <Attribute key={i} attribute={attribute} />
              ))}
            </SimpleGrid>
          </Panel>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  ) : null;
};

export default V2AttributesContainer;
